namespace TabAurous.Common {
    export enum PayrollFrequency {
        Daily = 1,
        Weekly = 2,
        Monthly = 3
    }
    Serenity.Decorators.registerEnumType(PayrollFrequency, 'TabAurous.Common.PayrollFrequency', 'HR.PayrollFrequency');
}
